var _style, _g, _path, _circle, _path2, _circle2, _path3, _circle3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgListPlus = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#034CD7;}\r\n\t.st1{fill:none;stroke:#034CD7;stroke-width:3.7;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M95.5,17.2c0-0.1-0.1-0.1-0.1-0.1c0-0.1-16.7-16.6-16.7-16.6s0,0-0.1-0.1C78.3,0.2,77.9,0,77.4,0h-53 c-3.2,0-5.9,2.6-5.9,5.8v19.6c1.2-0.6,2.5-1.1,3.8-1.4V5.8c0-1.2,1-2.1,2.1-2.1h51.1v14.6c0,1,0.8,1.9,1.9,1.9h14.8v69.9 c0,1.2-0.9,2.2-2.1,2.2H24.4c-1.2,0-2.1-0.9-2.1-2.1V73.1c-0.1,0-0.2,0-0.3-0.1c-1.2-0.3-2.4-0.6-3.5-1.1v18.2 c0,3.2,2.6,5.8,5.9,5.8h65.7c3.2,0,5.9-2.6,5.9-5.8V18.5C96,18,95.8,17.5,95.5,17.2z M79.3,16.5v-10l10.2,10.1H79.3V16.5z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.3,76.4C12.3,76.4,0,64.1,0,49s12.3-27.3,27.3-27.3C42.4,21.7,54.7,34,54.7,49S42.4,76.4,27.3,76.4z  M27.3,26c-12.7,0-23,10.3-23,23s10.4,23.1,23.1,23.1S50.5,61.7,50.5,49S40.1,26,27.3,26z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 65,
    cy: 37.2,
    r: 4.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.6,39.1H76.2c-1,0-1.9-0.8-1.9-1.9v0c0-1,0.8-1.9,1.9-1.9h11.4c1,0,1.9,0.8,1.9,1.9v0 C89.5,38.2,88.7,39.1,87.6,39.1z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 65,
    cy: 56.2,
    r: 4.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.6,58H76.2c-1,0-1.9-0.8-1.9-1.9v0c0-1,0.8-1.9,1.9-1.9h11.4c1,0,1.9,0.8,1.9,1.9v0 C89.5,57.2,88.7,58,87.6,58z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 65,
    cy: 75.2,
    r: 4.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.6,77H76.2c-1,0-1.9-0.8-1.9-1.9l0,0c0-1,0.8-1.9,1.9-1.9h11.4c1,0,1.9,0.8,1.9,1.9l0,0 C89.5,76.2,88.7,77,87.6,77z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.2,65.7h-3.6c-1.3,0-2.4-1.1-2.4-2.4V34.9c0-1.3,1.1-2.4,2.4-2.4h3.6c1.3,0,2.4,1.1,2.4,2.4v28.4 C30.6,64.6,29.5,65.7,28.2,65.7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.7,50.9v-3.6c0-1.3,1.1-2.4,2.4-2.4h28.4c1.3,0,2.4,1.1,2.4,2.4v3.6c0,1.3-1.1,2.4-2.4,2.4H12.2 C10.8,53.3,9.7,52.2,9.7,50.9z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgListPlus, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ListPlus.d84c8619.svg";
export { ForwardRef as ReactComponent };